export default "__VITE_ASSET__DilziNHU__"